import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import { YesNoIndicators } from '../../../global/models/api-model';
import { TcsmStates } from '../../../root/tcsm-model';
import { EmploymentData, EmploymentItem, MyCpgPodsSettings, MyCpgPodsTypes } from '../mycpg-pod-models';
import { PodGridContent } from './pod-grid-content';
import { PodGridContentItem } from './pod-grid-content-item';
import { PodGridItem } from './pod-grid-item';
import { PodGridItemHeader } from './pod-grid-item-header';


interface Props {
	settings: MyCpgPodsSettings;
}
export function EmploymentPod(props: Props) {

	const { settings } = props;
	const employmentData = useSelector<TcsmStates, EmploymentData>(state => state?.mycpgPodsState?.pods?.employment_data);
	const routeMatch = useRouteMatch();

	if (employmentData.show_pod === YesNoIndicators.No) {
		return null;
	}

	const renderPodContent = (employment: EmploymentItem) => {

		return (
			<>
				<PodGridContentItem>
					<p className='h4-styled'>{employment?.title}</p>
				</PodGridContentItem>
				<PodGridContentItem>
					<p className='h5-styled'>{employment?.job_title}</p>
				</PodGridContentItem>

				<PodGridContentItem>
					<p className='grey-caption'>{settings?.addressLabel}</p>
					<p >{`${employment?.address?.address1}, ${employment?.address?.city}, ${employment?.address?.state}, ${employment?.address?.postal_code}, ${employment?.address?.country}`}</p>
				</PodGridContentItem>

			</>
		);
	};

	function RenderDetailLink(){
		return (
			<>
				<Link to={`${routeMatch?.path}?type=${MyCpgPodsTypes.EMPLOYMENT}`}>{settings?.seeMoreLinkText}</Link>				
			</>
		);
	}

	return (
		<PodGridItem>
			<PodGridItemHeader title={settings?.employmentPodTitle}>
				<RenderDetailLink />
			</PodGridItemHeader>			
			{
				employmentData?.data?.map(a =>
					<PodGridContent key={a?.title}>
						{renderPodContent(a)}
					</PodGridContent>,
				)
			}
		</PodGridItem>

	);

}

